export default "__VITE_ASSET__B9293CVs__"